module.exports = __webpack_public_path__ + "static/media/janio-login-background.d2e7aa04.png";